interface Props {
  title: string;
  value: string | number;
  subtitle?: string;
  tone?: 'default' | 'success' | 'warning' | 'error';
}

const tones: Record<NonNullable<Props['tone']>, string> = {
  default: '',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
};

export default function KpiTile({ title, value, subtitle, tone = 'default' }: Props) {
  return (
    <div className="stat bg-base-100 rounded-box shadow">
      <div className="stat-title">{title}</div>
      <div className={`stat-value text-2xl ${tones[tone]}`}>{value}</div>
      {subtitle && <div className="stat-desc">{subtitle}</div>}
    </div>
  );
}
